import React, { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import { useTranslation } from "react-i18next";

function Search({
  handleSearch,
  placeholder = null,
  fullWidth = true,
  ...props
}) {
  const { t } = useTranslation();

  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (props.searchInputValue && props.searchInputValue !== "") {
      setInputValue(props.searchInputValue);
    }
  }, [props.searchInputValue]);

  const debouncedFormUpdate = useCallback(
    _.debounce(value => {
      handleSearch(value);
    }, 1000),
    []
  );

  const handleChange = e => {
    setInputValue(e.target.value);
    debouncedFormUpdate(e.target.value);
  };

  return (
    <Input
      {...props}
      value={inputValue}
      fullWidth={fullWidth}
      disableUnderline
      placeholder={placeholder ? placeholder : t("teams.searchFilter")}
      onChange={handleChange}
      startAdornment={
        <InputAdornment position="start">
          <SearchIcon />
        </InputAdornment>
      }
    />
  );
}

export default Search;
